import React from 'react';
import PageLayout from '../components/common/PageLayout';
import OtaCommissionList from '../components/finance/OtaCommissionList';

const OtaCommissionPage = () => (
  <PageLayout
    title="OTA Commission"
    showFinanceSectionTabs
    showBreadcrumbs={false}
    navLinks={[
      { url: '/finance/reports/', label: 'Reports' },
      { url: '/finance/rates/', label: 'Manage Rate' },
    ]}
  >
    <OtaCommissionList />
  </PageLayout>
);

export default OtaCommissionPage;
